import React from 'react';
import { connect } from 'react-redux';
import Typography from '@material-ui/core/Typography';

function StepperResult(props){
	const {enterpriseValue, currency, mailText} = props;
  var message = mailText;
  
  return(
    <div>
  		<Typography color="primary" variant="h5">
  			{message}
      </Typography>
      {props.iframesRedirectComponent}
    </div>
	);
}

function mapStateToProps(state){
  return { 
    mailText:state.estimation.mailText,
  };
}

export default connect(mapStateToProps)(StepperResult);